export function isLoggedIn() {
  return !!getLoginToken()
}

export function logOut() {
  localStorage.removeItem("jwt")
  location.reload()
}

export function getLoginToken() {
  return getLoginData()?.token
}

export function getIsAdmin() {
  return getLoginData()?.isAdmin
}

function getLoginData() {
  const jwtString = localStorage.getItem("jwt")
  if (!jwtString) {
    return undefined
  }
  const data: { token: string; isAdmin: boolean } = JSON.parse(jwtString)
  return data
}
